import { Chart } from 'react-google-charts';
import { useEffect, useState } from 'react';
import { Backend } from 'api/ApiConsumer';
import Loader from 'components/Loader';

const noop = function () {};

ColumnChart.defaultProps = {
  height: '400px',
  url: '',
  onDataLoad: noop,
  normaliseData: (data) => data,
  options: {},
};

export function ColumnChart({
  url,
  height,
  onDataLoad,
  normaliseData,
  options,
}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Backend.get(url)
      .then((res) => {
        setData(normaliseData(res.data));
        onDataLoad(true);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, [url]);

  return (
    <>
      {loading ? (
        <Loader upload_message={'loading'} full_height={true} />
      ) : (
        <Chart
          chartType="ColumnChart"
          width="100%"
          height={height}
          data={data}
          className={'shadow rounded'}
          options={{ annotations: { alwaysOutside: true }, ...options }}
        />
      )}
    </>
  );
}
